import jsPDF from "jspdf";

import { drawHeader } from "../../../component/WGRHeader";
import { drawFooter } from "../../../component/WGRFooter";
import { drawFinancialTable } from "./ucPDFTable";
import { handlePdf, PDF_ACTION } from "../../../../../utils/pdfHelper";

export default function generateWGRPDF(
  title,
  rows,
  grandTotal,  
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: "a4",
  });




  console.log(rows);





  //drawHeader(doc, title, month, year);

  drawFinancialTable(doc, rows);

  drawFooter(doc, month, year, title);

  handlePdf(doc, PDF_ACTION.VIEW);
}